import React, { useState, useEffect } from 'react';    
import { Link } from 'react-router-dom';    
import styled, { keyframes } from 'styled-components';    
import robots from '../components/List_robots';    
import roboOnImage from './images/robo_on.jpg';    
import roboOffImage from './images/robo_off.jpg';    
import { GOOGLE_DOCS_URL, fetchRobotStatus } from './api'; // api.js からインポート    
  
// 環境変数からデモモードを判断    
const isDemoMode = (process.env.REACT_APP_DEMO_MODE || 'false') === 'true';    
  
const Container = styled.div`    
  display: flex;    
  flex-direction: column;    
  padding: 0 20px 60px 20px;    
  background: #fafafa;    
  width: 100%;    
  margin: auto;    
  font-family: Arial, sans-serif;    
  box-sizing: border-box;    
  justify-content: flex-start;    
  align-items: stretch;    
  min-height: 100vh;    
`;    
  
const CardContainer = styled.div`    
  display: flex;    
  flex-direction: column;    
  gap: 20px;    
  width: 100%;    
  margin: 0 auto;    
  padding: 0 20px;    
  box-sizing: border-box;    
`;    
  
const Card = styled(Link)`    
  display: flex;    
  align-items: center;    
  justify-content: space-between;    
  background-color: #ffffff;    
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);    
  border-radius: 15px;    
  padding: 15px;    
  color: #333333;    
  text-decoration: none;    
  transition: transform 0.2s;    
  height: 100px;    
    
  &:hover {    
    transform: scale(1.02);    
  }    
`;    
  
const Img = styled.img`    
  border-radius: 10px;    
  width: 100px;    
  height: 100px;    
  object-fit: cover;    
  margin-right: 20px;    
`;    
  
const CardDetails = styled.div`    
  flex: 1;    
  display: flex;    
  flex-direction: column;    
  justify-content: center;    
`;    
  
const H3 = styled.h3`    
  font-family: YakuHanJP_Narrow, 'TTNorms-bold', 'RodinPro-B', 'YuGothic', '游ゴシック', 'Yu Gothic', 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', sans-serif;    
  font-size: 18px;    
  font-weight: bold;    
  margin: 0;    
  color: green;    
`;    
  
const P = styled.p`    
  font-size: 12px;    
  color: #666666;    
  margin: 0 0;    
  font-weight: bold;    
`;    
  
const Arrow = styled.div`    
  font-size: 24px;    
  margin-left: 20px;    
  color: green;    
  font-weight: bold;    
`;    
  
const zoomInOut = keyframes`    
  0% { transform: scale(1); }    
  50% { transform: scale(1.2); }    
  100% { transform: scale(1); }    
`;    
  
const AnimatedImage = styled.img`    
  border-radius: 8px;    
  width: 100px;    
  height: 100px;    
  object-fit: cover;    
  margin-right: 20px;    
  animation: ${zoomInOut} 2s infinite;    
`;    
  
const GreenButton = styled(Link)`    
  display: inline-block;    
  background-color: #007f3f;    
  color: white;    
  padding: 15px 30px;    
  text-align: center;    
  text-decoration: none;    
  border-radius: 8px;    
  font-size: 16px;    
  font-weight: bold;    
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);    
  transition: background-color 0.2s;    
    
  &:hover {    
    background-color: #005f2f;    
  }    
`;    
  
const getKindName = (kind) => {    
  switch (kind) {    
    case 'cu':    
      return 'キュウリ';    
    case 'gp':    
      return 'ピーマン';    
    default:    
      return kind;    
  }    
};    
  
const SelectMachine = () => {    
  const [robotStatuses, setRobotStatuses] = useState({});    
  
  // isDemoMode が true の場合、demo: true のロボットのみを表示  
  const filteredRobots = isDemoMode ? robots.filter(robot => robot.demo) : robots;  
    
  useEffect(() => {    
    window.scrollTo(0, 0); // ページのトップにスクロール    
  
    const updateStatuses = async () => {    
      const statuses = {};    
      for (const robot of filteredRobots) {    
        const status = await fetchRobotStatus(robot.name);    
        statuses[robot.name] = status;    
      }    
      setRobotStatuses(statuses);    
    };    
  
    updateStatuses();    
    const interval = setInterval(updateStatuses, 60000); // 1分ごとにステータスを更新    
    return () => clearInterval(interval);    
  }, [filteredRobots]);  // filteredRobots を依存関係に追加  
    
  return (    
    <Container>    
      <h2 style={{ color: '#333333', fontSize: '24px', fontWeight: 'bold' }}>    
        Aiロボ    
      </h2>    
      <CardContainer>    
        {filteredRobots.map((robot, index) => (    
          <Card to={`/${robot.name}`} key={index}>    
            <div style={{ display: 'flex', alignItems: 'center' }}>    
              {robotStatuses[robot.name] === '稼働中' ? (    
                <AnimatedImage src={roboOnImage} alt={robot.name} />    
              ) : (    
                <Img src={roboOffImage} alt={robot.name} />    
              )}    
              <CardDetails>    
                <H3>{robot.name}</H3>    
                <P>作物: {getKindName(robot.kinds)}</P>    
                <P>状況: {robotStatuses[robot.name] || '読み込み中...'}</P>    
                <P>場所: {robot.location}</P>    
              </CardDetails>    
            </div>    
            <Arrow>＞</Arrow>    
          </Card>    
        ))}    
        {!isDemoMode && (  // ここで条件付きレンダリングを行う
          <GreenButton to="/telemetry">すべてのロボットの収穫量を表示</GreenButton>  
        )}  
      </CardContainer>    
      <br />    
      {!isDemoMode && (  // ここで条件付きレンダリングを行う
        <Link    
          to={GOOGLE_DOCS_URL} // api.js からインポートしたURLを使用    
          style={{    
            color: '#333333',    
            textDecoration: 'none',    
            fontWeight: 'bold',    
            display: 'block',    
            textAlign: 'center',    
            marginTop: '20px'    
          }}    
        >    
          操作マニュアル    
        </Link>    
      )}
    </Container>    
  );    
};    
  
export default SelectMachine;    